import { MICROCOPY } from "@/data/content";

export const Marquee = () => {
  const items = [...MICROCOPY, ...MICROCOPY];
  return (
    <div className="overflow-hidden border-y border-white/10 bg-ink py-6" aria-hidden="true">
      <div className="animate-marquee flex w-max items-center whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {items.map((phrase, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display text-xl italic text-white/70 md:text-2xl">{phrase}</span>
                <span className="mx-10 inline-block h-2 w-2 rotate-45 bg-gold" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
